import { clsx } from 'clsx'
import {
  ExclamationCircleIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline'

interface Props {
  message: string
  size?: 'sm' | 'md' | 'lg'
  type?: 'error' | 'success' | 'info'
  icon?: 'exclamation' | 'info'
}

const Alert = ({ message, size = 'md', type = 'info', icon }: Props) => (
  <div
    className={clsx('flex items-center gap-2 rounded-xl p-3', {
      'bg-red-100': type == 'error',
      'bg-green-100': type == 'success',
      'bg-gray-100': type == 'info',
    })}
  >
    {icon == 'exclamation' ? (
      <ExclamationCircleIcon
        className={clsx('shrink-0', {
          'text-red-500': type == 'error',
          'text-green-500': type == 'success',
          'size-6': size == 'sm',
          'size-8': size == 'md',
          'size-10': size == 'lg',
        })}
      />
    ) : icon == 'info' ? (
      <InformationCircleIcon
        className={clsx('shrink-0', {
          'text-red-500': type == 'error',
          'text-green-500': type == 'success',
          'size-6': size == 'sm',
          'size-8': size == 'md',
          'size-10': size == 'lg',
        })}
      />
    ) : null}
    <span
      className={clsx('font-semibold', {
        'text-sm': size == 'sm',
        'text-base': size == 'md',
        'text-lg': size == 'lg',
      })}
    >
      {message}
    </span>
  </div>
)

export default Alert
